<template>
	<p v-if="!isLinkify"
		class="v-resume-text" 
		:class="[
			`v-resume-text--${color}`,
			miniSize ? 'v-resume-text--mini' : ''
		]">
		{{ text }}
	</p>
	<p v-else v-html="linkify(text)"
		class="v-resume-text" 
		:class="[
			`v-resume-text--${color}`,
			miniSize ? 'v-resume-text--mini' : ''
		]"></p>
	
</template>
<script>
import { linkify } from '@/_helpers/utils'

export default {
	props: {
		color: {
			type: String,
			default: 'primary'
		},
		miniSize: Boolean,
		text: String,
		isLinkify: Boolean
	},
	methods: {
      linkify(inputText) {
        return linkify(inputText);
      }
    }
}
</script>
<style lang="scss" scoped>
.v-resume-text {
	font-weight: normal;
	font-size: 15px;
	line-height: 24px;
	transition: color .35s ease;
	
	/* Colors */
	&--primary { color: #8D8D8D; }

	&--accent { color: #555555; }

	&--secondary { color: #C4B9D3; }

	/* Sizes */
	&--mini {
		font-size: 12px;
		line-height: 16px;
	}
}
</style>

<style lang="scss">
	.v-resume-text {
		a {
			&:hover,
			&:active {
				transition: color .35s ease !important;
				background: linear-gradient(278deg, #535DC1 0%, #A364D6 100%) !important;
				-webkit-background-clip: text !important;
				-webkit-text-fill-color: transparent !important;
			}
		}
	}
</style>